import React from 'react';
import { useStore } from '@cobuildlab/react-simple-state';
import { deleteUserDialogStore } from '../user-stores';
import { MuiDialog } from '../../../shared/components/dialog/MuiDialog';
import {
  useDeleteUserMutation,
  UsersDocument,
} from '../../../shared/types/generated';
import { deleteUserDialogStoreAction } from '../user-actions';

type DeleteUserDialogProps = {
  onSuccess?: () => void;
}

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({ onSuccess }) => {
  const { user, open } = useStore(deleteUserDialogStore);
  const handleClose = (): void => {
    deleteUserDialogStoreAction({ open: false, user: undefined });
  };
  const [update, { loading }] = useDeleteUserMutation({
    awaitRefetchQueries: true,
    refetchQueries: [UsersDocument],
    onCompleted: () => {
      handleClose();
      if (onSuccess) onSuccess();
    },
  });

  return (
    <MuiDialog
      open={Boolean(open)}
      handleClose={() => handleClose()}
      loading={loading}
      title='Delete'
      maxWidth='sm'
      fullWidth
      handleSuccess={() => {
        update({
          variables: {
            where: {
              id: user?.id,
            },
          },
        });
      }}
      renderActions
    >
      Do you want to delete user {user?.email}?
    </MuiDialog>
  );
};